module.exports = __webpack_public_path__ + "img/board.e8d36432.jpg";